import type { ComponentProps } from 'react';

export const CheckboxIcon = (props:ComponentProps<'svg'>) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="1.66216" y="1.66216" width="76.6757" height="76.6757" rx="11.6351" stroke="#81C73D"
          strokeWidth="3.32433" />
  </svg>
)